import {PERSON_ACTIVE_CONTEXTS_DATA__GET} from "../actions";

export default function(state = {}, action) {

//20190219
//payload is fuller dataset from db when already exists
//payload is just id from the new process -- from action createNewPersonForUser

  switch (action.type) {
    case PERSON_ACTIVE_CONTEXTS_DATA__GET:
      //console.log('rdcr_person_active_contexts action --PERSON_ACTIVE_CONTEXTS_DATA__GET --', action.payload)
      return action.payload;
    default:
      return state;
  }
}
